module.exports = __webpack_public_path__ + "media/images/flags/jp-19c631c1498ba5517cd5d01823f50e2a.svg";